import zoomSettings from "./zoom/zoomSettings";
import { setZoomControl } from "./zoom/zoomUtilities";
import { handleImagesPopup } from "./zoom/zoomPopup";
import { addZoomEvents } from "./zoom/zoomEvents";

const Zoom = {
  targetImagesSlider: false, // Recebe o objeto de swiper e o elemento alvo
  zoomOnHover: zoomSettings.zoomOnHover, // Aplica o zoom no hover, impossibilitando o zoom de click
  zoomOnClick: zoomSettings.zoomOnClick, // Aplica o zoom no click, impossibilitando o zoom no hover
  zoomPopup: zoomSettings.zoomPopup, // Ativa o popup da imagem 
  zoomOnPopup: zoomSettings.zoomOnPopup, // Ativa o zoom no popup
  zoomFactor: zoomSettings.zoomFactor, // Fator de zoom utilizado na imagem do popup
  zoomPopupInstance: false, // Armazena a instancia do popup criado
  zoomAnimationFrame: null, // Variável para controlar `requestAnimationFrame` e evitar execuções desnecessárias
  isZoomActive: false, // Estado inicial do zoom
  mouseBehaviorTimeControl: 0, // Variável para controlar o tempo de comportamento do mouse
   
 
  // Inicializa a funcionalidade de zoom nas imagens do slider
  initializeZoom: function() {
    const { targetImagesSlider } = Zoom
    if (!targetImagesSlider) return

    // Swiper que ira ter o zoom aplicado
    const gallery = targetImagesSlider.swiper;
    // Busca os slides com as imagens
    const mainImagesContainer = document.querySelector('[data-main-slider]');
    if (!gallery || !mainImagesContainer) return;

    // Busca os elementos de imagem que serão alvos dos eventos de zoom
    const zoomImages = mainImagesContainer.querySelectorAll('[data-image]');

    zoomImages.length > 0 && zoomImages.forEach((image, index) => {
      !window.mobile && addZoomEvents(image, gallery);
    });
  },

// ======================
// ======== Init ========
// ======================

  init: function (imagesSlider) {
    if (!imagesSlider) return;
    const { 
      initializeZoom,
      zoomPopup,
    } = Zoom;

    Zoom.targetImagesSlider = imagesSlider;

    setZoomControl();
    if (!window.mobile) {
      zoomPopup && handleImagesPopup();
      initializeZoom();
    } 
  }
}

export default Zoom;
